<template>
    <div v-if="show" class="account-auth-backdrop">
        <div class="account-auth-modal" :style="skin.my_account.content_background">
            <button type="button" class="account-auth-close" :style="skin.my_account.close_btn" @click="close">
                <i class="fas fa-times"></i>
            </button>
            <h4 class="account-auth-title" :style="skin.my_account.header_nav_text2">VERIFICAR USUARIO</h4>
            <form class="account-auth-form" @submit.prevent="verify">
                <div class="account-auth-field" :style="skin.my_account.header">
                    <label for="accountAccessPassword">{{ translate('password') }}</label>
                    <input id="accountAccessPassword" v-model="password" type="password" autocomplete="current-password"
                        :placeholder="translate('enter_password')" :disabled="loading" required>
                </div>
                <button type="submit" class="account-auth-submit" :style="skin.qbet.booking_btn" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    verificar
                </button>
                <div v-if="status.message" :class="'alert alert-' + status.type" role="alert">
                    {{ status.message }}
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

const CLIENT_ID = '1_5i50wo24kpcscc0okw0ww4gsc8kwg0k8gs0ok44skooww4swcg';
const CLIENT_SECRET = '18qxs6584gw08scg8wsk8gow44oc4gcw40c4o8w44880g0gkcg';

export default {
    name: 'AccountAccessAuthModal',
    props: ['show', 'skin', 'language', 'translation'],
    data() {
        return {
            password: '',
            loading: false,
            status: {
                message: '',
                type: ''
            }
        }
    },
    computed: {
        user() {
            return this.$store.getters['getUserData'];
        }
    },
    watch: {
        show(value) {
            if (value) {
                this.password = '';
                this.status.message = '';
                this.status.type = '';
            }
        }
    },
    methods: {
        close() {
            this.password = '';
            this.status.message = '';
            this.status.type = '';
            this.$emit('close');
        },
        async verify() {
            if (!this.password) {
                this.status.message = this.translate('enter_password');
                this.status.type = 'danger';
                return;
            }

            this.loading = true;
            this.status.message = '';
            this.status.type = '';

            try {
                const response = await axios.post(
                    `${this.user.domain}/api/usuario/checklogin?access_token=${this.user.token}`,
                    {
                        client_id: CLIENT_ID,
                        client_secret: CLIENT_SECRET,
                        password: this.password
                    }
                );
                const flag = response.data?.flag ?? response.data?.data?.flag;

                if (flag === true) {
                    this.password = '';
                    this.$emit('verified');
                    return;
                }

                this.status.message = response.data?.message || response.data?.data?.message || 'Contraseña incorrecta';
                this.status.type = 'danger';
            } catch (error) {
                this.status.message = error.response?.data?.message || error.response?.data?.error || 'No se pudo verificar el usuario';
                this.status.type = 'danger';
            } finally {
                this.loading = false;
            }
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                const new_text_serched = text.replace(/ /g, '_');
                if (this.$props.translation[new_text_serched]) {
                    return this.$props.translation[new_text_serched][this.$props.language];
                }
            }
            return text;
        }
    }
}
</script>

<style scoped>
.account-auth-backdrop {
    position: fixed;
    inset: 0;
    z-index: 4;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 18px;
}

.account-auth-modal {
    position: relative;
    width: 100%;
    min-height: 260px;
    padding: 12px 24px 24px;
    color: white;
    border-top: 2px solid #2D49A0;
}

.account-auth-title {
    margin: 0 0 12px;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
}

.account-auth-close {
    position: absolute;
    top: 16px;
    right: 18px;
    border: 0;
    background: transparent;
    font-size: 28px;
    line-height: 1;
}

.account-auth-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
}

.account-auth-field {
    width: min(470px, 100%);
    padding: 12px 30px 24px;
}

.account-auth-field label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
}

.account-auth-field input {
    width: 100%;
    border: 0;
    padding: 11px;
    background: #333;
    color: white;
    font-size: 12px;
}

.account-auth-field input::placeholder {
    color: white;
    opacity: 0.9;
}

.account-auth-submit {
    min-width: 118px;
    border: 0;
    padding: 10px 20px;
    color: white;
}

.alert {
    width: min(470px, 100%);
    margin: 0;
}

@media (max-width: 768px) {
    .account-auth-modal {
        min-height: 100vh;
        padding: 54px 16px 24px;
    }

    .account-auth-title {
        font-size: 24px;
    }

    .account-auth-field {
        padding: 12px 16px 20px;
    }
}
</style>
